module.exports = __webpack_public_path__ + "static/media/finalizado.c884f427.svg";